// @flow
import * as constants from './constants';

import { createAction } from 'redux-actions';
import { curry } from 'lodash/fp';

export const initiateHolidayMode = createAction(constants.INITIATE_HOLIDAYMODE);

export const initializeState = createAction(constants.INITIALIZE_STATE);

export const dateSelected = createAction(constants.DATE_SELECTED, (timezone, date) => ({
    timezone,
    date
}));

export const exitHolidayModeScreen = createAction(constants.EXIT_HOLIDAY_MODE_SCREEN);

export const setHolidayMode = createAction(constants.SET_HOLIDAY_MODE, (start, end, temperature, e) => ({
    start,
    end,
    temperature,
    event: e
}));

export const temperatureChange = createAction(constants.TEMPERATURE_CHANGE);

export const timeChange = curry((position, timezone, time) => ({
    type: constants.TIME_CHANGE,
    payload: {
        position,
        time,
        timezone
    }
}));

export const editingHolidayMode = createAction(constants.EDITING_HOLIDAY_MODE);
export const disableHolidayMode = createAction(constants.DISABLE_HOLIDAY_MODE);



// WEBPACK FOOTER //
// ./src/core/state/holiday-mode/actions.js